<template lang="pug">
  v-breadcrumbs(:items="breadcrumbs" large)
    template(v-slot:item="{ item }")
      v-breadcrumbs-item(:to="item.to" :disabled="item.disabled" :exact="item.exact")
        div(style="position:relative")
          span.px-4.overline(v-if="item.super" style="color: grey; position:absolute; top:-17px; left:-15px") {{item.super}}
          span(v-if="item.icon")
            v-icon(large) {{item.icon}}
          span(v-else) {{item.text}}
    template(v-slot:divider)
      v-icon(large) mdi-chevron-right
</template>

<script>
export default {
  props: ['data'],
  data: () => ({
    breadcrumbBase: [{
      icon: 'home',
      to: { name: 'index' },
      exact: true
    }]
  }),
  computed: {
    breadcrumbs() {
      if(Array.isArray(this.data))
        return this.breadcrumbBase.concat(this.data)
      else
        return this.breadcrumbBase
    }
  }
}
</script>